<template><ListFilter field="gis_category" :options="opts" label="GIS категория" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/></template>
<script>
import ListFilter from './ListFilter.vue'
export default { name:'GisCategoryFilter', components:{ListFilter}, data(){ return { opts:['Биология','Геммология','Геология','Осадки','Палеонтология'] } } }
</script>
